import { HttpMethod, ServiceStatus, ApiService } from "./types";

// ─── Helpers / Constants ──────────────────────────────────────────────────────

export const STATUS_COLORS: Record<ServiceStatus, string> = {
  Stable: "#22C55E",
  Beta: "#F59E0B",
  Deprecated: "#EF4444"
};

export const STATUS_BG: Record<ServiceStatus, string> = {
  Stable: "green.50",
  Beta: "yellow.50",
  Deprecated: "red.50"
};

export const STATUS_TEXT: Record<ServiceStatus, string> = {
  Stable: "green.700",
  Beta: "yellow.700",
  Deprecated: "red.700"
};

export const METHOD_COLORS: Record<HttpMethod, { bg: string; color: string }> =
  {
    GET: { bg: "#3B82F6", color: "white" },
    POST: { bg: "#22C55E", color: "white" },
    PUT: { bg: "#F97316", color: "white" },
    DELETE: { bg: "#EF4444", color: "white" },
    PATCH: { bg: "#A855F7", color: "white" }
  };

export function getTotalEndpoints(services: ApiService[]) {
  return services.reduce(
    (total, s) => total + s.groups.reduce((t, g) => t + g.endpoints.length, 0),
    0
  );
}

export function serviceMatchesFilter(service: ApiService, filter: string) {
  const q = filter.toLowerCase().trim();
  if (!q) return true;
  return (
    service.name.toLowerCase().includes(q) ||
    service.baseUrl.toLowerCase().includes(q) ||
    service.status.toLowerCase().includes(q) ||
    service.version.toLowerCase().includes(q) ||
    service.description.toLowerCase().includes(q)
  );
}
